import { Hidden } from 'braid-design-system';

import MobileCampaign from '../Campaign/MobileCampaign';
import { StandaloneCampaign } from '../StandaloneCampaign/StandaloneCampaign';

import {
  useDesktopTarzanCampaignContent,
  useMobileTarzanCampaignContent,
} from './useTarzanCampaignContent';

export const TarzanCampaignBanner = () => {
  const desktopProps = useDesktopTarzanCampaignContent();
  const mobileProps = useMobileTarzanCampaignContent();
  return (
    <>
      <Hidden above="mobile">
        <MobileCampaign {...mobileProps} type="standalone" />
      </Hidden>
      <Hidden below="tablet">
        <StandaloneCampaign {...desktopProps} />
      </Hidden>
    </>
  );
};
